import { getSafeRedirectForRole } from "./privateRouteAccess";

/** True when the auth status API confirms an active session. */
export function isAuthenticatedStatusResponse(response) {
  const data = response?.data;
  return data?.authenticated === true && data?.role != null && data?.role !== "N/A";
}

/** Where to send an already-authenticated user (role-safe). */
export function getPostLoginRedirectPath(role) {
  return getSafeRedirectForRole(role);
}
